import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import IntegrationsTabs from './IntegrationsTabs';

const IntegrationsLayout = () => {
  const { user } = useAuth();

  if (user?.role !== 'AD') {
    return <Navigate to="/403" replace />;
  }

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        px: { xs: 2, sm: 4 },
        py: { xs: 3, sm: 5.5 },
        maxWidth: 1180,
        mx: 'auto',
      }}
    >
      <Box sx={{ mb: 3.5 }}>
        <Typography
          sx={{
            fontSize: 28,
            fontWeight: 700,
            letterSpacing: '-0.02em',
            color: '#10131A',
            mb: 0.75,
          }}
        >
          Integrations
        </Typography>
        <Typography sx={{ fontSize: '14.5px', color: '#4B5264', m: 0 }}>
          Connect and manage your marketing channels and integrations.
        </Typography>
      </Box>

      <IntegrationsTabs />

      <Box sx={{ flex: 1, minWidth: 0, minHeight: 0, overflow: 'auto' }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default IntegrationsLayout;
